import { h } from 'preact';
export const UserX = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("path", { d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
        h("circle", { cx: "8.5", cy: "7", r: "4" }),
        h("line", { x1: "18", y1: "8", x2: "23", y2: "13" }),
        h("line", { x1: "23", y1: "8", x2: "18", y2: "13" })));
};
//# sourceMappingURL=user-x.js.map